import { FC } from 'react';
import CardCss from '#srcCssModules/card/card.module.scss';
import { CardLocationHeader } from '#home/components/card-location/CardLocationHeader';
import { CardLocationBody } from '#home/components/card-location/CardLocationBody';
import { useBaseContext } from '#base/hooks/use-base-context';

const CardLocation: FC = () => {
  const { hasCityList } = useBaseContext();

  if (!hasCityList) {
    return null;
  }

  return (
    <div className={CardCss.card}>
      <CardLocationHeader />
      <CardLocationBody />
    </div>
  );
};

export { CardLocation };
